import { useState } from "react"
import { ExternalLink } from "lucide-react"

const NAP = "Jero-One Technologies Limited · Downtown Entebbe, P.O. Box 171736, Kampala GPO, Uganda · +256 766 553 449 · info@jero-onetechnologies.com · https://www.jero-onetechnologies.com"

const STEPS = [
  { id: "gsc", title: "Google Search Console", desc: "Verify the site (HTML tag method, send the code to your developer), then submit sitemap.xml.", url: "https://search.google.com/search-console" },
  { id: "gbp-ug", title: "Google Business Profile: Entebbe/Kampala", desc: "Create or claim the Uganda office listing. Use exactly the business details below, add photos and ask clients for reviews.", url: "https://business.google.com/create" },
  { id: "gbp-us", title: "Google Business Profile: Eden Prairie, MN", desc: "13875 Chestnut Dr, Ste 318, Eden Prairie, MN 55344 · +1 682-461-4255", url: "https://business.google.com/create" },
  { id: "bing", title: "Bing Places for Business", desc: "Import directly from your Google Business Profile once it is verified.", url: "https://www.bingplaces.com/" },
  { id: "clutch", title: "Clutch: Uganda IT Services", desc: "Create a free company profile and request 2–3 client reviews.", url: "https://clutch.co/get-listed" },
  { id: "techbehemoths", title: "TechBehemoths: Kampala IT directory", desc: "Free company listing with services and portfolio.", url: "https://techbehemoths.com/" },
  { id: "nita", title: "NITA-U certified providers list", desc: "Confirm Jero-One Technologies Limited appears correctly (CCL2) and the website link is set.", url: "https://www.nita.go.ug/" },
  { id: "crunchbase", title: "Crunchbase company profile", desc: "Add founding year (2009), HQ (Minnesota), offices and website.", url: "https://www.crunchbase.com/add-new" },
  { id: "linkedin", title: "LinkedIn company page", desc: "Make sure the website, phones and locations match the site exactly.", url: "https://www.linkedin.com/company/105114983/" },
]

const KEY = "jero-listing-checklist"

export function ListingsPanel() {
  const [done, setDone] = useState(() => JSON.parse(localStorage.getItem(KEY) || "{}"))
  const toggle = (id) => {
    const next = { ...done, [id]: !done[id] }
    setDone(next)
    localStorage.setItem(KEY, JSON.stringify(next))
  }
  const count = STEPS.filter((s) => done[s.id]).length
  return (
    <div className="space-y-4" data-testid="listings-panel">
      <div className="rounded-2xl border border-brand/10 bg-white p-5">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-brand">Get listed: local SEO checklist</h3>
          <span className="text-sm font-semibold text-brand-500" data-testid="listings-progress">{count}/{STEPS.length} done</span>
        </div>
        <p className="mt-2 text-sm text-muted-foreground">Use exactly the same business details everywhere. Google ranks consistent listings higher:</p>
        <p className="mt-2 rounded-lg bg-brand-50 px-3 py-2 font-mono text-xs text-brand" data-testid="listings-nap">{NAP}</p>
      </div>
      {STEPS.map((s) => (
        <div key={s.id} className="flex items-start gap-4 rounded-2xl border border-brand/10 bg-white p-5" data-testid={`listing-${s.id}`}>
          <input type="checkbox" checked={!!done[s.id]} onChange={() => toggle(s.id)} className="mt-1 h-5 w-5 accent-[#1B5E35]" data-testid={`listing-check-${s.id}`} />
          <div className="flex-1">
            <div className={`font-semibold ${done[s.id] ? "text-muted-foreground line-through" : "text-brand"}`}>{s.title}</div>
            <div className="mt-1 text-sm text-muted-foreground">{s.desc}</div>
          </div>
          <a href={s.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white hover:bg-brand-700" data-testid={`listing-open-${s.id}`}>
            Open <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
      ))}
    </div>
  )
}
